import { firstNonEmptyUrl, teamingAppIcon } from "@/utils/organizationLogo"

type EventWithOrganization = {
	logo?: string | null
	organization?: {
		logo?: string | null
		default_image?: string | null
	} | null
}

/**
 * Activity logo: client logo, organization default image, Teaming App icon.
 * The organization logo is never shown inside an activity.
 */
export function resolveEventDisplayImage(event: EventWithOrganization | null | undefined): string {
	if (!event) return teamingAppIcon
	return firstNonEmptyUrl(event.logo, event.organization?.default_image) ?? teamingAppIcon
}
